export interface GeocoderResult {
  /** WGS-84 longitude */
  longitude: number;
  /** WGS-84 latitude */
  latitude: number;
  /** Nominatim's best-guess display name for the resolved location */
  displayName: string;
}

/**
 * Resolves a US address string to WGS-84 coordinates via Nominatim (OpenStreetMap).
 * Free, no API key required. Suitable for low-volume admin/on-save calls.
 * Returns null if the address can't be resolved.
 */
export async function geocodeAddress(address: string): Promise<GeocoderResult | null> {
  try {
    const url =
      `https://nominatim.openstreetmap.org/search` +
      `?q=${encodeURIComponent(address)}&format=json&limit=1&countrycodes=us`;
    const res = await fetch(url, {
      headers: {
        "Accept-Language": "en",
        // Nominatim ToS requires a meaningful User-Agent or Referer
        "User-Agent": "grateful8-platform/1.0",
      },
    });
    if (!res.ok) return null;
    const data = (await res.json()) as Array<{
      lon: string;
      lat: string;
      display_name: string;
    }>;
    const first = data[0];
    if (!first) return null;
    return {
      longitude: parseFloat(first.lon),
      latitude: parseFloat(first.lat),
      displayName: first.display_name,
    };
  } catch {
    return null;
  }
}
